import { lazy } from 'react';
import { createRoute } from '@tanstack/react-router';
import { Route as rootRoute } from './__root';
import { authGuard } from './guards';

const Register = lazy(() => import('../views/default/Register'));

export const Route = createRoute({
  getParentRoute: () => rootRoute,
  path: '/register',
  beforeLoad: authGuard({ publicOnly: true }),
  component: Register,
});
